export default function Configure($stateProvider) {
    $stateProvider.state('seuilsecu', {
        parent: 'common',
        url: '/seuilsecu',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.SECURITE_PERSONNEL" | translate }}'
        }
    });

    $stateProvider.state('seuilsecu.list', {
        url: '/list',
        template: '<references-controle></references-controle>',
        rights: { domain: 'seuilsecu', right: 'read' },
        ncyBreadcrumb: {
            parent: 'seuilsecu',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCES_LIST" | translate}}'
        },
        navigation: {
            menu: 'securite_personnel_donnees',
            translate: 'REFERENCES.BREADCRUMBS.REFERENCES_LIST',
            order: 6
        },
        search: 'REFERENCES.BREADCRUMBS.REFERENCES_LIST'
    });

    $stateProvider.state('seuilsecu.list.detail', {
        url: '/{id}',
        template: '<reference-controle-detail></reference-controle-detail>',
        rights: { domain: 'seuilsecu', right: 'read' },
        ncyBreadcrumb: {
            parent: 'seuilsecu.list',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('seuilsecu.new', {
        url: '/new',
        template: '<reference-controle-form></reference-controle-form>',
        rights: { domain: 'seuilsecu', right: 'create' },
        ncyBreadcrumb: {
            parent: 'seuilsecu.list',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCE_NEW" | translate}}'
        },
        search: 'REFERENCES.BREADCRUMBS.REFERENCE_NEW'
    });

    $stateProvider.state('seuilsecu.edit', {
        url: '/{id}/edit',
        template: '<reference-controle-form></reference-controle-form>',
        rights: { domain: 'seuilsecu', right: 'update' },
        ncyBreadcrumb: {
            parent: 'seuilsecu.list',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCE_EDIT" | translate }}'
        }
    });

    $stateProvider.state('seuilsecu.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: { parentState: 'seuilsecu.new' },
        ncyBreadcrumb: {
            parent: 'seuilsecu.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });

    $stateProvider.state('seuilsecu.duplicate', {
        url: '/{id}/duplicate',
        template: '<reference-controle-form></reference-controle-form>',
        rights: { domain: 'seuilsecu', right: 'create' },
        ncyBreadcrumb: {
            parent: 'seuilsecu.list',
            label: '{{ "REFERENCES.BREADCRUMBS.REFERENCE_NEW" | translate}}'
        },
        params: {
            duplicate: true
        }
    });
}

Configure.$inject = ['$stateProvider'];
